import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import { Button, Card, Progress, Tag } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { isBuyer, isExporter, isVerifiedFreightEligible } from "../../../util/helper";
import { CERT_KEY } from "../../../util/Constant";
import { getAttchementByKey } from "../../myProfile/MyProfileView";
import { isValidString } from "util/ApiHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useGetBreakpoints } from "../../../hooks/useGetBreakpoints";

export const calculateProfilePercent = (authUser) => {
  let percent = 100;
  const pending = [];

  if (!authUser.address) {
    percent -= 5;
    pending.push("Address");
  }
  if (!authUser.companyLogo || !isValidString(authUser.companyLogo)) {
    percent -= 5;
    pending.push("Company Logo");
  }
  if (isExporter(authUser)) {
    if (!isValidString(getAttchementByKey(authUser, CERT_KEY.EXIM)?.src)) {
      percent -= 5;
      pending.push("EXIM Certificate");
    }
    if (!isValidString(getAttchementByKey(authUser, CERT_KEY.GST)?.src)) {
      percent -= 5;
      pending.push("GST Certificate");
    }
  }
  if (isBuyer(authUser)) {
    if (!isValidString(getAttchementByKey(authUser, CERT_KEY.COMPANY)?.src)) {
      percent -= 5;
      pending.push("Company Certificate");
    }
  }

  return { percent, pending };
};

const VerificationBanner = ({ showButton }) => {
  const {isMobile } = useGetBreakpoints();
  const authUser = useSelector(({ auth }) => auth.userData);
  const [profilePercent, setProfilePercent] = useState(0);
  const [pendingFields, setPendingFields] = useState([]);
  console.log(authUser);

  useEffect(() => {
    const { pending, percent } = calculateProfilePercent(authUser);
    setProfilePercent(percent);
    setPendingFields(pending);
  }, [authUser]);
  const history = useHistory();
  const navigateProfile = () => {
    history.push(`/my-profile`);
  };

  return (
    <div>
      <Card>
        <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: isMobile ? "column" : "row", gap: "10px" }}>
          <div>
            <div style={{ fontSize: 48, fontWeight: "bold" }}>
              {profilePercent}%
            </div>
            <div className="gx-h1-sm gx-font-weight-semi-bold">
              PROFILE COMPLETED
            </div>
            {isVerifiedFreightEligible(authUser) && authUser?.verifiedFreight && (
  <div
    style={{
      marginTop: 10,
      display: "inline-flex",
      alignItems: "center",
      gap: 10,
      padding: "8px 16px 8px 10px",
      borderRadius: 999,
      background: "#e8f5e9",
      border: "1.5px solid #a5d6a7",
      color: "#1b5e20",
      fontWeight: 700,
      fontSize: 14,
      fontFamily: "system-ui, sans-serif",
    }}
  >
    <svg
      width="22"
      height="22"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#2e7d32"
        d="M25,2 C26.8,2 28.3,3.2 30,3.8 C31.7,4.4 33.6,4 35.2,4.9
           C36.8,5.8 37.8,7.4 39.1,8.6 C40.4,9.8 42.2,10.4 43.2,11.9
           C44.2,13.4 44.2,15.3 44.8,17 C45.4,18.7 46.8,20 47,21.8
           C47.2,23.6 46.4,25.3 46.2,27.1 C46,28.9 46.6,30.8 46,32.5
           C45.4,34.2 44,35.4 43.1,36.9 C42.2,38.4 41.9,40.2 40.8,41.5
           C39.7,42.8 38,43.5 36.7,44.5 C35.4,45.5 34.4,47 32.9,47.6
           C31.4,48.2 29.7,47.8 28.1,48 C26.5,48.2 25,49 23.4,48.8
           C21.8,48.6 20.5,47.6 19,47 C17.5,46.4 15.8,46.6 14.4,45.7
           C13,44.8 12.2,43.3 11,42.1 C9.8,40.9 8.2,40.1 7.3,38.7
           C6.4,37.3 6.4,35.6 5.8,34 C5.2,32.4 4,31.1 3.8,29.3
           C3.6,27.5 4.2,25.8 4.2,24 C4.2,22.2 3.4,20.4 3.6,18.6
           C3.8,16.8 5,15.3 5.6,13.7 C6.2,12.1 6,10.2 7,8.8
           C8,7.4 9.6,6.7 10.9,5.6 C12.2,4.5 13.2,3 14.8,2.4
           C16.4,1.8 18.1,2.4 19.8,2.2 C21.5,2 23.2,2 25,2Z"
      />
      <polyline
        points="14,26 21,33 36,17"
        fill="none"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span>Verified Freight</span>
  </div>
)}
          </div>
          <div style={{ width: "100%" }}>
            <Progress percent={profilePercent} showInfo={false} />
            {profilePercent < 100 ? (
              <>
                <div className="myexim-table-title">
                  Complete KYC to get profile verified !!
                </div>
                <div className="gx-pt-2">
                  Why Verify?
                  <br />
                  KYC Update adds verified to Your Profile and adds credibility
                  and Trust when your profile is viewed by other parties.
                  {pendingFields.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                      <span className="gx-font-weight-bold">
                        Pending Details: &nbsp;
                      </span>
                      {pendingFields.map((field, index) => (
                        <Tag color="red"> {field}</Tag>
                      ))}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="myexim-table-title">
                  Awesome !! Your KYC update is compeleted.
                </div>
                <div className="gx-pt-2">
                  Your verification will be completed within 24 hours.
                </div>
                <div className="gx-pt-2">
                  <Tag color="red"> {"Pending Admin Approval"}</Tag>
                </div>
              </>
            )}
          </div>
        </div>
        {showButton && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button type="primary" onClick={navigateProfile}>
              Go to Profile Page
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default VerificationBanner;
